import { render, staticRenderFns } from "./ReceivingScan.vue?vue&type=template&id=18d607fe&scoped=true&"
import script from "./ReceivingScan.vue?vue&type=script&lang=js&"
export * from "./ReceivingScan.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingScan.vue?vue&type=style&index=0&id=18d607fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d607fe",
  null
  
)

export default component.exports